import React from 'react';
import { FaCamera } from 'react-icons/fa';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';


export const PhotoComponent = ({
  selectedMentors, changeImage
}: any) => {

  return (
    <>
      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>
        <div className=' py-4'>
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <div>
                        <InputLabelContainer label="Pictures" />
                        <img
                          src={selectedMentors?.PhotoUrl}
                          className="w-12 h-12"
                        />
                        <div
                          onClick={() => changeImage(
                         
                            'Url',
                            'image',
                            selectedMentors,
                           
                          )}
                        >
                          <FaCamera className=' text-2xl text-skin-ouprimary' />
                        </div>
                      </div>
         
          </div>
        </div>
      </div>
    </>
  )
}

export default PhotoComponent;
